import React, { useEffect, useRef } from "react";

const Quote2025Preview = (props) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    // Update iframe content when landingPagePreview changes
    if (iframeRef.current && props.landingPagePreview.html) {
      const iframe = iframeRef.current;
      const doc = iframe.contentDocument || iframe.contentWindow.document;

      doc.open();
      doc.write(props.landingPagePreview.html);
      doc.close();

      // Set iframe height based on content
      iframe.onload = () => {
        try {
          const iframeDocument =
            iframe.contentDocument || iframe.contentWindow.document;
          const height = iframeDocument.documentElement.scrollHeight;
          iframe.style.height = height + "px";
        } catch (error) {
          console.log("Could not resize iframe:", error);
          // Fallback height
          iframe.style.height = "800px";
        }
      };
    }
  }, [props.landingPagePreview.html]);

  return (
    <div>
      <h3 className="text-center mt-20 mb-20">2025 Quote PDF Preview</h3>
      {/* No allow-scripts: the landing-page HTML embeds quote/lead text and
          must never execute in the CRM origin (matches the trip previews). */}
      <iframe
        ref={iframeRef}
        id="quote2025PreviewFrame"
        sandbox="allow-same-origin"
        style={{
          width: "100%",
          minHeight: "600px",
          border: "1px solid #ddd",
          borderRadius: "4px",
        }}
        title="2025 Quote Preview"
      />
    </div>
  );
};

export default Quote2025Preview;
